import { mapResponse } from 'shared/api/lib/mapResponse'
import { templateInstallationsApi } from 'shared/api/requests/templateInstallations'
import { type TemplateInstallation } from 'shared/api/requests/templateInstallations/schemas'
import { createListSlice } from 'shared/lib/factory/redux/createListSlice'
import { createListOperations } from 'shared/lib/factory/redux/createListSlice/lib/createListOperations'
import { createAsyncAction } from 'shared/lib/redux'

import { Statuses } from '../constants/TemplateInstallations'

const NAMESPACE = 'templateInstallations'

const templateInstallationsSlice = createListSlice({
  namespace: NAMESPACE,
  storePath: `templates.${NAMESPACE}`,

  listKey: 'templates',

  operations: createListOperations({
    getList: mapResponse(templateInstallationsApi.fetch, (response) => response.data),
    getNextList: mapResponse(templateInstallationsApi.fetch, (response) => response.data),
    getPrevList: undefined,
    createItem: undefined,
    deleteItem: undefined,
    updateItem: undefined,
  }),

  getItemId: (item: TemplateInstallation) => {
    return item.template_installation_id
  },

  extraState: {
    template_installations_count: 0,
  },
  reducers: {},
})

export const {
  actions: templateInstallationsActions,
  reducer: templateInstallationsReducer,
  selectors: templateInstallationsSelectors,
} = templateInstallationsSlice

export type TemplateInstallationsState = ReturnType<typeof templateInstallationsReducer>

export const toggleTemplateActivationForPage = createAsyncAction(
  `${NAMESPACE}/toggleActivation`,
  (
    {
      status,
      template_installation_id,
      page_id,
    }: {
      status: boolean
      template_installation_id: number
      page_id: number
    },
    { getState, dispatch },
  ) => {
    const state = getState()
    const item = templateInstallationsSelectors.getItemById(state, template_installation_id)
    if (!status) {
      dispatch(
        templateInstallationsActions.updateItem({
          id: template_installation_id,
          data: { ...item, status: Statuses.DISABLED },
        }),
      )
      return templateInstallationsApi.disableTemplateForPage({
        body: { page_id, template_installation_id },
      })
    }
    dispatch(
      templateInstallationsActions.updateItem({
        id: template_installation_id,
        data: { ...item, status: Statuses.ACTIVE },
      }),
    )
    return templateInstallationsApi.enableTemplateForPage({
      body: { page_id, template_installation_id },
    })
  },
)
